/* eslint-disable @typescript-eslint/no-explicit-any */
import { Field } from "formik"
import React from "react"

interface IProps {
  className?: string
  name: string
  value?: string
  type?: string
  autoFocus?: boolean
  autoComplete?: string
  innerRef?: React.RefObject<HTMLInputElement>
  onChange: (e: React.ChangeEvent<any>) => void
  onBlur: (e: React.FocusEvent<any>) => void
  onFocus?: (e: React.FocusEvent<any>) => void
  as?: string
  skipClasses?: string
  maxLength?: number
  isDisabled?: boolean
}

const InputField: React.FC<IProps> = ({
  className,
  name,
  value,
  type = "text",
  autoFocus,
  autoComplete,
  innerRef,
  onChange,
  onBlur,
  onFocus,
  as,
  skipClasses,
  maxLength,
  isDisabled = false
}: IProps): JSX.Element => {
  const defaultClasses = ["flex", "w-full", "text-ch-gray-600", "py-2", "px-3", "rounded", "border", "border-ch-blue-alt-300", "leading-tight", "focus:outline-none", "focus:shadow-outline", "appearance-none", "focus:ring-2", "ring-ch-blue-alt-300"]
  const propClasses = className ? className.split(" ") : []
  const skipList = skipClasses ? skipClasses.split(" ") : []
  const allClasses = [...defaultClasses, ...propClasses]
  const filteredClasses = allClasses.filter((cls) => !skipList.includes(cls)).join(" ")
  return (
    <Field
      innerRef={innerRef}
      autoFocus={autoFocus}
      type={type}
      name={name}
      id={name}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      value={value}
      autoComplete={autoComplete}
      className={filteredClasses}
      maxLength={maxLength}
      as={as}
      disabled={isDisabled}
    />
  )
}

export default InputField
